import { createContext, useCallback, useEffect, useState } from "react";
import { getUnits } from "../services/masterData.service";

export const MasterDataContext = createContext(null);

export const MasterDataProvider = ({ children }) => {
    const [units, setUnits] = useState([]);

    const fetchUnits = useCallback(async () => {
        const unitsData = await getUnits();
        setUnits(unitsData);
    }, []);

    useEffect(() => {
        fetchUnits();
    }, [fetchUnits]);

    return (
        <MasterDataContext.Provider
            value={{
                units,
            }}
        >
            {children}
        </MasterDataContext.Provider>
    );
};